import React from 'react';
import './Layout.scss';
import NavbarHeader from "components/Header/NavbarHeader";
interface LayoutProps {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ className = '', contentClassName = '', children }) => {
  // const logOut = () => {
  //   sessionStorage.removeItem('token')
  //   localStorage.removeItem('token')
  //   window.location.href = '/dang-nhap'
  // }

  return (
    <>
      <div className={`app menu-collapsed ${className}`}>
        <div className='app-main'>
          <NavbarHeader></NavbarHeader>
          {/* <Header /> */}
          <div className="container" data-container-main>
            <div className="layout-wrapper">
              <div className={`page ${contentClassName}`}>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Layout;
